import ENV from "config/Env";
import { backendQueryKey, localQueryKey, permanentBackendQueryKey } from "hooks/useTypedQuery";

import type { SEASONS, Tyre } from "models";
import type { PAGE_SIZE } from "utils/common";
import type { PaginatedItems } from "utils/paginatedItems";

const component = "TyresDashboard";

export type TyreFilters = {
  page: number;
  page_size: PAGE_SIZE;
  manufacturer: string | null;
  description: string | null;
  ean: string | null;
  carry_capacity: number | null;
  width: number | null;
  height: number | null;
  size: number | null;
  speed: string | null;
  season: SEASONS | null;
};

export const TyresDashboardQueryKeys = {
  brands: permanentBackendQueryKey<string[]>({ component, baseUrl: ENV.carBaseURL, endpoint: "/tyres/brands/list" }),
  filters: localQueryKey<TyreFilters>({ component, data: "filters" }),
  tyres: backendQueryKey<PaginatedItems<Tyre>>({ component, baseUrl: ENV.carBaseURL, endpoint: "/tyres/list" })
};
